let ymFn = null;
let ymPromise = null;

export async function reachGoal(name) {
    try {
        if (ymFn) {
            ymFn("reachGoal", name);
            return;
        }

        if (!ymPromise) {
            ymPromise = import("react-yandex-metrika").then((m) => {
                // В разных версиях может быть по-разному — подстрахуемся
                ymFn = m.default || m.ym || m;
                return ymFn;
            });
        }

        const fn = await ymPromise;
        if (typeof fn === "function") fn("reachGoal", name);
    } catch (e) {
        // тихо игнорим, чтобы не ломать UX
    }
}
